import { Component } from '@angular/core';
import { BrowserSupportService } from './browser-support.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-browser-support-modal',
    templateUrl: './browser-support-modal.component.html',
    styleUrls: ['./browser-support-modal.component.scss'],
    standalone: false
})
export class BrowserSupportModalComponent {
  readonly modalContainerId = 'browser-not-supported-modal';
  readonly message: Observable<string>;
  constructor(readonly browserSupportService: BrowserSupportService) {
    this.message = this.browserSupportService.supportedBrowserNames.pipe(
      map(supportedBrowsers => {
        if (supportedBrowsers.length > 0) {
          const supportedBrowserNames = supportedBrowsers.includes('Edge') ?
            $localize`Chrome, Firefox, Edge, or Safari` :
            $localize`Chrome, Firefox, or Safari`;
          return $localize`To access the Voatz Web App, please update to the most recent version of ${supportedBrowserNames}.`;
        } else {
          return $localize`To access the Voatz Web App, please use a desktop or laptop system instead of this mobile browser. If permitted for your election, you may also download and use the Voatz Mobile App`;
        }
      }),
    );
  }
}
